export default {
    setGrupoPerguntas(state, item) {
        state.grupo_perguntas = item;
    },
}